module.exports = __webpack_public_path__ + "img/carta-cocteles-restaurante.c9a5ad84.jpg";